import { observer } from 'mobx-react-lite'

import { Form, FormField } from '@/Core/UI/Form'
import { FieldCell, FieldGrid } from '@/Ship/Components/EntityCard'
import { Hint } from '@/Ship/Components/Hint'

import { isActivityCompleted } from '../Helpers/activityOverdue'

import type { ActivityFormContextLike } from '../Contracts/Activity.types'

/**
 * Блок «Результат» (`SPEC-011` §8.4, К-15, К-16): сам результат на всю
 * ширину, а «Ким завершено» й «Дата та час завершення» — лише в завершеної
 * справи (С11.3: легасі їх зберігав, але не показував).
 *
 * Окремий observer: видимість залежить від статусу, а шаблон значень полів
 * не читає (`SPEC-002` §4.2).
 */
export const ActivityResultFields = observer(
    ({ formContext, isNew }: { formContext: ActivityFormContextLike; isNew: boolean }) => {
        const isCompleted = isActivityCompleted(formContext.values)

        return (
            <>
                {!isNew && !isCompleted ? (
                    <Hint id="crm.activity.result">
                        Результат можна вписати заздалегідь: кнопка «Завершити справу» підставить його у вікно
                        завершення. Завершену справу знову відкрити не можна.
                    </Hint>
                ) : null}
                <Form formContext={formContext}>
                    <FieldGrid>
                        <FieldCell wide>
                            <FormField name="result" />
                        </FieldCell>
                        {isCompleted ? (
                            <FieldCell key="doneBy">
                                <FormField name="doneBy" />
                            </FieldCell>
                        ) : null}
                        {isCompleted ? (
                            <FieldCell key="doneAt">
                                <FormField name="doneAt" />
                            </FieldCell>
                        ) : null}
                    </FieldGrid>
                </Form>
            </>
        )
    }
)
